import { Button } from "@mui/material";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { useGlobalContext } from "context/GlobalContext";
import React, { useState } from "react";
import dayjs from "configs/dayjs.config";

import { useProjectContext } from "../context";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { updateProjectApi } from "API/apis/project/updateProject";
import { ProjectTopBanner } from "../components/ProjectTopBanner";
import { projectOperationsList } from "../constants/project.constants";
import { DatePickerWrapper } from "components/DateTimePicker/DatePicker";
import { dateTimeFormat } from "constants/componentsConstants";

const initialState = {
  id: 0,
  projectName: "",
  deliveryDate: new Date(),
  budget: 0,
  clientAddress: "",
  clientContactNo: "",
  clientEmail: "",
};
export const UpdateProject = () => {
  const { setError, setSuccess, setIsLoading } = useGlobalContext();
  const { setCurrentOperationPage, previewProject, setReloadRequired } =
    useProjectContext();
  const [formData, setFormData] = useState(previewProject);

  const handleDeliveryDateChange = (newValue) => {
    if (newValue) {
      setFormData({
        ...formData,
        deliveryDate: dayjs(newValue.toDate()).format(dateTimeFormat.date),
      });
    }
  };
  const handleUpdateUserSubmit = async (e) => {
    e.preventDefault();
    try {
      if (dayjs().subtract(1, "day") > formData.deliveryDate) {
        throw new Error("Older dates are not allowed");
      }

      setIsLoading(true);
      const { data, status } = await updateProjectApi({
        deliveryDate: formData.deliveryDate,
        id: formData.id,
      });
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      setFormData(initialState);
      setReloadRequired(true);
      setSuccess(data?.message);
      setCurrentOperationPage(projectOperationsList.listProject);
      setIsLoading(false);
    } catch (error) {
      setError(error.message);
      setIsLoading(false);
    }
  };
  return (
    <>
      <PageTitle pageName={pageName.project.update} />
      <ProjectTopBanner
        buttonType="back"
        enquiryOperationsParam={projectOperationsList.listProject}
      />
      <form onSubmit={handleUpdateUserSubmit}>
        <DatePickerWrapper
          label="Delivery Date"
          value={dayjs(formData.deliveryDate)}
          onChange={(newValue) => handleDeliveryDateChange(dayjs(newValue))}
        />
        <Button variant="contained" type="submit" fullWidth>
          Submit
        </Button>
      </form>
    </>
  );
};
